import { VayvayService } from './services/vayvay.service';
import { Component } from '@angular/core';
import { CpanelService } from './services/cpanel.service';
import { LanguageService } from './services/language.service';
import { SettingService } from './services/setting.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent {
  constructor(
    private vayvay: VayvayService,
    private cpanelService: CpanelService,
    private languageService: LanguageService,
    private settingService: SettingService,
  ) {}

  ngOnInit() {
    this.settingService.getSettings();
    this.settingService.getSettings();
    this.vayvay.Services().LanguageService.setInitialAppLanguage();

    this.cpanelService.getCountryConfig().subscribe((res: any) => {
      if (res.data) {
        this.languageService.availableLanguages.next(res.data.countryLangs);
        this.languageService.country.next(res.data);
        this.settingService.getPlans(res.data._id);
      }
    });
  }
}
